/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_GenerateInputs */



/**
* | output |
* | --- |
* | "Generate report" |
*
* @param {Meeting_Report_GenerateInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_generate = /** @type {((inputs?: Meeting_Report_GenerateInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_GenerateInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Genereer verslag")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rédiger le compte rendu")
	return /** @type {LocalizedString} */ ("Generate report")
});